module.exports = __webpack_public_path__ + "img/how-it-works-3.e9362256.jpg";